"use client";

import { SelectFilter } from "@/forms/filters/select-filter/select-filter";
import { CheckboxFilter } from "@/forms/filters/checkbox-filter/checkbox-filter";
import { Sort } from "@/components/common/sort/sort";
import { trans } from "@/service/i18n/i18n";
import { cn } from "@/lib/utils";

export const Controls = ({
  filters,
  hideKinds = false,
}: {
  filters: any;
  hideKinds?: boolean;
}) => {
  return (
    <div className={"mb-6"}>
      <div className={`text-base-foreground mt-6 mb-2 text-lg font-semibold`}>
        Filtruj
      </div>

      <div className={"flex flex-col gap-4 lg:flex-row lg:justify-between"}>
        <div
          className={cn(
            "grid grid-cols-1 items-center gap-4 sm:grid-cols-2 md:grid-cols-[repeat(2,160px)_110px_220px]",
            hideKinds && "md:grid-cols-[160px_110px_220px]",
          )}
        >
          <SelectFilter filter={filters.price} />
          {!hideKinds && <SelectFilter filter={filters.kinds} />}
          <CheckboxFilter filter={filters.withoutPrescription} />
          <CheckboxFilter filter={filters.forNurse} />
        </div>
        <Sort
          sortOptions={[
            {
              title: trans("sort.ascending"),
              sort: "alphabet",
              sortOrder: "asc",
            },
            {
              title: trans("sort.descending"),
              sort: "alphabet",
              sortOrder: "desc",
            },
            {
              title: "Od najwyższej ceny (100%)",
              sort: "price",
              sortOrder: "desc",
            },
            {
              title: "Od najniższej ceny (100%)",
              sort: "price",
              sortOrder: "asc",
            },
          ]}
        />
      </div>
    </div>
  );
};
